import {segment} from './helpers'

/**
 * Tracks when looks are successfully created
 * @param {String} name The name of the look
 * @param {String} origin Where the look creation was initiated from
 */
export const createdLook = (name, origin) => segment('Created Look', {name, origin})
